import React, { useState } from 'react';
import InputField from '../../component/form/FormInput';
import Button from '../../component/ui/Button';
import { toast } from 'react-toastify';
import { createPaymentTerm } from '../../services/vendor';

const AddPaymentTerms = ({
	paymentTerms,
	setPaymentTerms,
	handleInputChange,
	setOpenPaymentTermsModal,
}) => {
	const [error, setError] = useState('');
	const [paymentTerm, setPaymentTerm] = useState('');

	async function handleAddNewPaymentTerm(event) {
		event.preventDefault();

		if (!paymentTerm) {
			setError('Payment terms cannot be empty');
			return;
		}

		try {
			const res = await createPaymentTerm(paymentTerm);
			if (res.success) {
				setPaymentTerms([
					{
						key: res?.data?.payment_terms_id,
						value: 'Net ' + res?.data?.term_name,
					},
					...paymentTerms,
				]);

				toast.success(res?.message);
				handleInputChange('payment_terms', 'Net ' + res?.data?.term_name);
				setOpenPaymentTermsModal(false);
				setPaymentTerm('');
				setError('');
			} else if (res.success === false) {
				setError(res.message);
				toast.error(res?.message);
			}
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	return (
		<div>
			<form
				className="add-productgroup-form"
				onSubmit={handleAddNewPaymentTerm}
				noValidate
			>
				<InputField
					label="Payment Terms"
					placeholder="Enter Payment Terms"
					type="text"
					name="payment-term"
					autoFocus={true}
					value={paymentTerm}
					onChange={(val) => {
						if (/^\d*$/.test(val) || val === '') {
							setPaymentTerm(val);
							setError('');
						} else {
							setError('Only numbers are allowed');
						}
					}}
					error={error}
				/>

				<span>
					<Button
						type="submit"
						className="btn-primary mt-4 px-5 w-auto"
						button="Done"
					/>
				</span>
			</form>
		</div>
	);
};

export default AddPaymentTerms;
